import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './index.css';

import App from './App';
import './i18n';
//import reportWebVitals from './reportWebVitals';

import ReactGA from "react-ga4";

import configureStore from './store/store';
const store = configureStore();

// init GA
ReactGA.initialize(process.env.REACT_APP_GA_ID);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
